type ClassValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | Record<string, any>
  | ClassValue[];

export function cn(...inputs: ClassValue[]): string {
  return inputs
    .filter(Boolean)
    .map((input) => {
      if (typeof input === 'string') return input;
      if (typeof input === 'number') return String(input);
      if (typeof input === 'boolean') return '';
      if (Array.isArray(input)) return cn(...input);
      if (typeof input === 'object' && input !== null) {
        return Object.entries(input)
          .filter(([, value]) => Boolean(value))
          .map(([key]) => key)
          .join(' ');
      }
      return '';
    })
    .join(' ')
    .trim();
}
